"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentZone = void 0;
var react_1 = __importDefault(require("react"));
var ContentZone = function (_a) {
    var name = _a.name, page = _a.page, sitemapNode = _a.sitemapNode, dynamicPageItem = _a.dynamicPageItem, languageCode = _a.languageCode, channelName = _a.channelName, getModule = _a.getModule, isDevelopmentMode = _a.isDevelopmentMode, isPreview = _a.isPreview, globalData = _a.globalData;
    if (!page)
        return null;
    var modules = page.zones[name];
    return (react_1.default.createElement(react_1.default.Fragment, null, modules.map(function (m) {
        var AgilityModule = getModule(m.moduleName);
        var props = {
            page: page,
            sitemapNode: sitemapNode,
            dynamicPageItem: dynamicPageItem,
            module: m.item,
            languageCode: languageCode,
            channelName: channelName,
            customData: m.customData || null,
            isDevelopmentMode: isDevelopmentMode,
            isPreview: isPreview,
            globalData: globalData,
        };
        if (AgilityModule) {
            return react_1.default.createElement(AgilityModule, __assign({ key: m.item.contentID }, props));
        }
        else {
            if (isPreview || isDevelopmentMode) {
                return (react_1.default.createElement("div", null,
                    "The component for",
                    " ",
                    react_1.default.createElement("em", null,
                        react_1.default.createElement("strong", null, m.moduleName)),
                    " ",
                    "was not found in the Agility Modules list."));
            }
            throw new Error("Component for ".concat(m.moduleName, " was not found in the Agility Modules list."));
        }
    })));
};
exports.ContentZone = ContentZone;
